<div id="couponModal" class="modal fade text-center coupon-modal {{modalClass}}" tabindex="-1" aria-labelledby="couponModalLabel" aria-hidden="true">
	<div class="modal-dialog">
		<div class="modal-content {{modalContentClass}}">
			<div class="modal-header flex-column justify-content-center border-0">
				<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="{{closeLabel}}"></button>
				<img src="{{logoPath}}" class="{{logoClass}}" alt="{{logoAltText}}" width="{{logoWidth}}" height="{{logoHeight}}" class="img-fluid" />
			</div>
			<div class="modal-body">
				<div class="coupon-content">
					<div class="h1" id="couponModalLabel">{{statusHeadline}}</div>
					{{statusSubtitle}}
					{{#if validCoupon}}
					<div class="coupon-details">
						{{{couponText}}}
					</div>
					{{/if}}
				</div>
			</div>
			<div class="modal-footer justify-content-center border-0">
				<img class="m-0" src="{{monsterPath}}" alt="{{monsterAltText}}" width="{{monsterWidth}}" height="{{monsterHeight}}">
			</div>
		</div>
	</div>
</div>